import { Component, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Document } from '@ceres/domain';

@Component({
    selector: 'ceres-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent {
    @Input() activeDocuments: Document[] = [];
    @Input() isNewItem = false;
    @Input() archiving = true;
    @Input() validFileTypes: string[] | undefined;
    @Input() uploading = false;

    @Output() changed = new EventEmitter<any>();
    @Output() uploadRequested = new EventEmitter<void>();

    newDocDataSource: MatTableDataSource<any>;
    dndFiles: File[] = [];
    selectedFiles: Set<File> = new Set();
    showWarningArchive = false;
    showWarningDelete = false;
    validDrag: any;

    displayedColumnsDataNew = ['select', 'name', 'delete'];

    deleteSelected() {
        this.dndFiles = this.dndFiles.filter((dndFile) => !this.selectedFiles.has(dndFile));
        this.changedFile();
    }

    changeDeleteStatus(file: File, checked: boolean): void {
        if (checked) {
            this.selectedFiles.add(file);
        } else {
            this.selectedFiles.delete(file);
        }
    }

    changedFile() {
        if (!this.isNewItem) {
            this.showWarningArchive = false;
            this.showWarningDelete = false;

            this.dndFiles.forEach((newDoc: File) => {
                const i = this.activeDocuments.findIndex((doc: Document) => doc.name === newDoc.name);
                if (i > -1) {
                    if (!this.archiving) {
                        this.showWarningDelete = true;
                    } else {
                        this.showWarningArchive = true;
                    }
                }
            });
        }
        this.newDocDataSource = new MatTableDataSource(this.dndFiles);
        this.selectedFiles = new Set([...this.selectedFiles].filter((file) => this.dndFiles.includes(file)));
        this.changed.emit(this.dndFiles);
    }

    cancelNewDocument(index: number) {
        this.dndFiles.splice(index, 1);
        this.changedFile();
    }

    clearFiles(): void {
        this.dndFiles = [];
        this.changedFile();
    }

    protected get allowedFileTypes(): string {
        if (this.validFileTypes) {
            return this.validFileTypes.join(', ');
        }
        return '';
    }
}
